import { Job } from '../job';

export class JobSerializer {
    fromJson(json: any): Job {
        const data = new Job();
        data.id = json.id;
        data.name = json.name;
        data.technology=json.technology;
        data.jobCategory=json.jobCategory;
        data.jobPriority=json.priority ? json.priority : 'N/A';
        data.jobStatus = json.jobStatus ? json.jobStatus : 'N/A';
        data.noOfVacancies = json.noOfVacancies;
        data.createdOn = json.createdOn;
        data.createdBy=json.createdBy;
        data.jobDescription = json.jobDescription;
        data.jobAssignedRecruiter =json.jobAssignedRecruiter;
        data.openJobCount=json.openJobCount;
        data.pendingJobCount =json.pendingJobCount;
        data.closedJobCount=json.closedJobCount;
        data.lastModifiedBy=json.lastModifiedBy;
        data.specialAttribute=json.specialAttribute;
        data.jobCommentCount=json.jobCommentCount;
        data.cvSubmitEnabled = json.cvSubmitEnabled;
        data.hiringManager = json.hiringManager;
        data.expectedOfferDate = json.expectedOfferDate,
        data.expectedJoiningDate = json.expectedJoiningDate,
        data.expectedOfferExtendedDate = json.expectedOfferExtendedDate,
        data.expectedJoiningExtendedDate = json.expectedJoiningExtendedDate,
        data.expectedOfferWeeks = json.expectedOfferWeeks,
        data.expectedOfferExtendedWeeks = json.expectedOfferExtendedWeeks,
        data.expectedJoiningWeeks = json.expectedJoiningWeeks,
        data.primaryRecruiter = json.primaryRecruiter,
        data.expectedJoiningExtendedWeeks = json.expectedJoiningExtendedWeeks
        // data.expectedOffer = json.expectedOffer;
        // data.expectedJoining = json.expectedJoining
        return data;
    }

    toJson(data: Job): any {
        return {
            id: data.id,
            technology: data.technology,
            jobStatus: data.jobStatus,
            jobCategory: data.jobCategory,
            noOfVacancies: data.noOfVacancies,
            description: data.description,
            priority: data.jobPriority,
            createdOn:data.createdOn,
            jobDescription: data.jobDescription,
            jobAssignedRecruiter :data.jobAssignedRecruiter,
            openJobCount:data.openJobCount,
            closedJobCount:data.closedJobCount,
            pendingJobCount:data.pendingJobCount,
            jobCommentCount :data.jobCommentCount,
            createdBy :data.createdBy,
            lastModifiedBy :data.lastModifiedBy,
            specialAttribute:data.specialAttribute,
            hiringManager:data.hiringManager,
            expectedOfferDate : data.expectedOfferDate,
            expectedJoiningDate : data.expectedJoiningDate,
            expectedOfferExtendedDate : data.expectedOfferExtendedDate,
            expectedJoiningExtendedDate : data.expectedJoiningExtendedDate,
            expectedOfferWeeks : data.expectedOfferWeeks,
            expectedOfferExtendedWeeks : data.expectedOfferExtendedWeeks,
            expectedJoiningWeeks : data.expectedJoiningWeeks,
            primaryRecruiter : data.primaryRecruiter,
            expectedJoiningExtendedWeeks : data.expectedJoiningExtendedWeeks
            // expectedJoining:data.expectedJoining,
            // expectedOffer:data.expectedOffer
        };
    }
}
